import PropTypes from 'prop-types';

import 'components/Label/Label.less';

const Label = ({ children, type, dataQa }) => (
    <span className={`invoices-label invoices-label_${type}`} data-qa={dataQa}>
        {children}
    </span>
);

Label.propTypes = {
    children: PropTypes.node,
    type: PropTypes.string,
    dataQa: PropTypes.string,
};

export default Label;
